import React, { PureComponent } from "react";
import "./spinner.scss";


const XAxis = class extends PureComponent {


    render() {
        return (
            <div className="spinner">
                <div className="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
            </div>
        )
    }


}

export default XAxis